import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [운영설정 > 관리자원] managetype_id와 managetype_key에 따른 rsctype 목록을 조회한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  getRsctypeList(params) {
    return axios.post(`${baseUrl}/settings/common/rsc/get-rsctype-list.do`, params);
  },
  /**
   * [운영설정 > 관리자원] managetype_id와 rsctype_id에 따른 rsc 목록을 조회한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  getRscList(params) {
    return axios.post(`${baseUrl}/settings/common/rsc/get-rsc-list.do`, params);
  },
  /**
   * [운영설정 > 관리자원] rsctype 추가시 rsctypeID의 중복을 체크한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  checkRsctypeIdValidation(params) {
    return axios.post(`${baseUrl}/settings/common/rsc/check-rsctype-id-validation.do`, params);
  },
  /**
   * [운영설정 > 관리자원] rsctype 추가/변경 팝업창에서 필요한 수집방식 목록을 조회한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  getRscGetmethodList(params) {
    return axios.post(`${baseUrl}/settings/common/rsc/get-rsc-getmethod-list.do`, params);
  },
  /**
   * [운영설정 > 관리자원] rsctype 추가/변경 팝업창에서 필요한 판단 주기 설정 리스트를 가져온다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  getEventJudgementList() {
    return axios.get(`${baseUrl}/settings/common/rsc/get-event-judgement-list.do`);
  },
  /**
   * [운영설정 > 관리자원] rsctype 추가/변경 팝업창에서 SQL수집방식의 정책 목록을 조회한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  getRuleRscGetmethodSourceList() {
    return axios.get(`${baseUrl}/settings/common/rsc/get-rule-rsc-getmethod-source-list.do`);
  },
  /**
   * [운영설정 > 관리자원] rsctype을 추가한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  insertRsctype(params) {
    return axios.post(`${baseUrl}/settings/common/rsc/insert-rsctype.do`, params);
  },
  /**
   * [운영설정 > 관리자원] rsctype들을 삭제한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  deleteRsctypes(params) {
    return axios.post(`${baseUrl}/settings/common/rsc/delete-rsctypes.do`, params);
  },
  /**
   * [운영설정 > 관리자원] rsc 추가/수정 팝업에서 이벤트 메시지 포멧 목록을 조회한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  getEventMessageFormatListByManagetypeId(params) {
    return axios.post(`${baseUrl}/settings/common/rsc/get-event-message-format-list-by-managetype-id.do`, params);
  },
  /**
   * [운영설정 > 관리자원] rsc 추가/수정 팝업에서 자원 수집 결과 형태 목록을 조회한다
   * @author najongdang
   * @return {[type]}        [description]
   */
  getRscDatatypeList() {
    return axios.get(`${baseUrl}/settings/common/rsc/get-rsc-datatype-list.do`);
  },
  /**
   * [운영설정 > 관리자원] rsc 추가시 rscID의 중복을 체크한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  checkRscIdValidation(params) {
    return axios.post(`${baseUrl}/settings/common/rsc/check-rsc-id-validation.do`, params);
  },
  /**
   * [운영설정 > 관리자원] rsc 추가.
   * @author najongdang
   * @return {[type]}        [description]
   */
  insertRsc(params) {
    return axios.post(`${baseUrl}/settings/common/rsc/insert-rsc.do`, params);
  },
  /**
   * [운영설정 > 관리자원] rsc들 삭제.
   * @author najongdang
   * @return {[type]}        [description]
   */
  deleteRscs(params) {
    return axios.post(`${baseUrl}/settings/common/rsc/delete-rscs.do`, params);
  },
  /**
   * [운영설정 > 관리자원] rsctype 수정
   * @author najongdang
   * @return {[type]}        [description]
   */
  updateRsctypes(params) {
    return axios.post(`${baseUrl}/settings/common/rsc/update-rsctypes.do`, params);
  },
  /**
   * [운영설정 > 관리자원] rsc 수정
   * @author najongdang
   * @return {[type]}        [description]
   */
  updateRsc(params) {
    return axios.post(`${baseUrl}/settings/common/rsc/update-rsc.do`, params);
  },
  /**
   * [운영설정 > 관리자원] 데이터소스 추가시 sourceId의 중복을 체크한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  checkSourceIdValidation(params) {
    return axios.post(`${baseUrl}/settings/common/rsc/check-source-id-validation.do`, params);
  },
  /**
   * [운영설정 > 관리자원] rule_rsc_getmethod_source 데이서소스를 추가한다
   * @author najongdang
   * @return {[type]}        [description]
   */
  insertDataSource(params) {
    return axios.post(`${baseUrl}/settings/common/rsc/insert-rule-rsc-getmethod-source.do`, params);
  },
  /**
   * [운영설정 > 관리자원] rule_rsc_getmethod_source 데이서소스를 수정한다
   * @author najongdang
   * @return {[type]}        [description]
   */
  updateDataSource(params) {
    return axios.post(`${baseUrl}/settings/common/rsc/update-rule-rsc-getmethod-source.do`, params);
  },
  /**
   * [운영설정 > 관리자원] rule_rsc_getmethod_source 데이서소스를 삭제한다
   * @author najongdang
   * @return {[type]}        [description]
   */
  deleteDataSource(params) {
    return axios.post(`${baseUrl}/settings/common/rsc/delete-rule-rsc-getmethod-source.do`, params);
  },
  /**
   * [운영설정 > 관리자원] rule_rsc_getmethod_source 사용여부를 체크한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  checkRuleRscGetmethodSourceInUse(params) {
    return axios.post(`${baseUrl}/settings/common/rsc/check-rule-rsc-getmethod-source-id-use.do`, params);
  },
  /**
   * 운영 > 수집 설정 > 스냅샷 주기 설정 - 스냅샷 판단 기준 목록 조회
   * @author Song
   * @return {Object}
   */
  getObjImportanceLevelList() {
    return axios.get(`${baseUrl}/settings/common/rsc/get-obj-importance-level-list.do`);
  },
  /**
   * 운영 > 수집 설정 > 스냅샷 주기 설정 - 스냅샷 주기 리스트 조회
   * @author Song
   * @return {Object}
   */
  getSnapshotPeriodList(params) {
    return axios.post(`${baseUrl}/settings/common/rsc/get-snapshot-period-list.do`, params);
  },
  /**
   * 운영 > 수집 설정 > 스냅샷 주기 설정 - 스냅샷 주기를 업데이트한다.
   * @author Song
   * @return {Object}
   */
  updateSnapshotPeriodList(params) {
    return axios.post(`${baseUrl}/settings/common/rsc/update-snapshot-period-list.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/common/rsc-settings.js